import moment from "moment/moment";

const storeValidator = {
	name: {
		rules: [
			{
				//test: /^[a-z0-9A-Z_\sА-Яа-яҐЄІЇїіє]+$/,
				test:/.*/,
				message: 'Please enter valid name',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	// email: {
	// 	rules: [
	// 		{
	// 			test: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
	// 			message: 'Please enter valid email',
	// 		},
	// 	],
	// 	errors: [],
	// 	valid: false,
	// 	state: '',
	// },
	countryCode: {
		rules: [
			{
				test: /^[a-z0-9A-Z_\sА-Яа-яҐЄІЇїіє]+$/,
				message: 'Please select valid country',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	cityGeonameId: {
		rules: [
			{
				test: /^[a-z0-9A-Z_\s-\sА-Яа-яҐЄІЇїіє]+$/,
				message: 'Please select valid city',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
    latitude: {
        rules: [
            {
                test: (value) => !value || /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(value),
                message: 'Invalid value',
            },
        ],
        errors: [],
        valid: false,
        state: '',
    },
    longitude: {
        rules: [
            {
                test: (value) => !value || /^[-+]?((1[0-7]\d|[1-9]?\d)(\.\d+)?|180(\.0+)?)$/.test(value),
                message: 'Invalid value',
            },
        ],
        errors: [],
        valid: false,
        state: '',
    },
	address: {
		rules: [
			{
				test:/.*/,
				message: 'Please enter valid address',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	status: {
		rules: [
			{
				test: /^[a-z0-9A-Z_\sА-Яа-яҐЄІЇїіє]+$/,
				message: 'Please select valid status',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
};

export default storeValidator;



// WEBPACK FOOTER //
// ./src/helpers/storeValidator.js